import { SetClientNotificationsStateHandler } from '../../gameClient/clientCommands/SetClientNotificationsStateHandler';
import { GameClient } from '../../gameClient/gameClient';
import { NotificationsWrap } from '../../general/modules/notifications/NotificationsWrap';

export class GetNotificationsStateHandler {
    public handle(): void {
        NotificationsWrap.isWebPushSubscribed()
            .then((response) => {
                const result = response;
                GameClient.getInstance().sendCommand(new SetClientNotificationsStateHandler({
                    isAccessPush: result
                }));
            })
            .catch((err) => {
                window.Sentry.captureException(err);
                GameClient.getInstance().sendCommand(new SetClientNotificationsStateHandler({
                    isAccessPush: false
                }));
            });
    }
}
